import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Api} from '../../api/api';
import {createSchedule} from '../../api/functions';
import {LocationStateService} from '../../common/services/location-state.service';
import {Schedule} from '../../api/models/schedule';

@Component({
  selector: 'app-schedule',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './schedule.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./schedule.component.css'],
})
export class ScheduleComponent {
  private readonly api = inject(Api);
  private readonly locationStateService = inject(LocationStateService);

  sampleJson = `{
  "type": "NORMAL",
  "recipient": "0518d382-c229-4b95-a6b6-34390d8f2767",
  "expiresAt": "2026-06-27T19:43:44.105+02:00",
  "scheduledActions": [
    {
      "cron": "0 0 * * * *",
      "minSoC": 20,
      "maxPurchaseSoC": 80,
      "type": "setPowerTo",
      "value": null,
      "registerName": null,
      "registerIndex": null
    }
  ],
  "redo": false
}`;
  scheduleInput: string = this.sampleJson;
  response: any = null;
  error: string | null = null;
  loading = false;

  get formattedScheduleInput(): string {
    try {
      return JSON.stringify(JSON.parse(this.scheduleInput), null, 2);
    } catch {
      return this.scheduleInput;
    }
  }

  saveAndSendFahrplan() {
    this.error = null;
    this.response = null;
    this.loading = true;
    const locationId = this.locationStateService.currentLocation()?.id;
    if (!locationId) {
      this.error = 'No location selected.';
      this.loading = false;
      return;
    }

    try {
      const parsed = JSON.parse(this.scheduleInput) as Schedule;
      this.api
        .invoke(createSchedule, {
          location_id: locationId,
          body: parsed,
        })
        .then((res) => {
          this.response = res;
          this.loading = false;
        })
        .catch((err: {message?: string}) => {
          this.error = err.message || 'Error occurred';
          this.loading = false;
        });
    } catch (e: any) {
      this.error = 'Invalid JSON: ' + e.message;
      this.loading = false;
    }
  }

  onScheduleInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement | null;
    if (target && typeof target.value === 'string') {
      this.scheduleInput = target.value;
    }
  }
}
